import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Link from 'gatsby-link'
import startCase from 'lodash/startCase'
import compose from 'recompose/compose'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import SimpleCard from 'components/SimpleCard'
import Phaser from 'components/Phaser'
import { RootMeta } from 'components/Meta'

const styles = (theme) => ({
  container: {
    padding: 20,
  },
  header: {
    border: '1px solid red',
  },
  mentionCount: {
    color: theme.palette.accent.noticeLight,
    fontSize: '1.2em',
    fontWeight: 500,
  },
  goButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    position: 'absolute',
    right: 10,
    bottom: -8,
  },
})

const WeightLossWorkoutsPage = ({ classes, data }) => {
  const {
    site: { siteMetadata },
  } = data
  const workouts = data.allMarkdownRemark.edges
  const markdownHtml = data.markdownRemark.html
  const thumbnails = data.allImageSharp.edges

  const thumbnailResolutions = thumbnails.reduce((acc, { node }) => {
    const { originalName } = node.resolutions
    const thumbName = originalName.slice(
      0,
      originalName.search(/\.(jpg|jpeg|png|gif)$/i),
    )
    if (!acc[thumbName]) acc[thumbName] = node.resolutions
    return acc
  }, {})

  return (
    <div>
      <RootMeta
        url={siteMetadata.siteUrl}
        title={`Workouts curated for Weight Loss | ${siteMetadata.siteName}`}
        description="Exercises known in the past to provide positive results for weight loss are assembled here. These exercises are actively formulated with weight loss in mind and were established by intensive research."
        breadCrumb={[]}
      />
      <Grid classes={{ container: classes.container }} spacing={24} container>
        <Grid xs={12} item>
          <Phaser label="Workouts for Weight Loss" noBottom />
        </Grid>
        <Grid xs={12} item>
          <Typography dangerouslySetInnerHTML={{ __html: markdownHtml }} />
          <Typography style={{ fontWeight: 500 }}>
            Want to submit a mention? Click{' '}
            <Link to="/submit-mention">here</Link>.
          </Typography>
        </Grid>
        <Grid xs={12} item>
          <Grid spacing={24} justify="center" container>
            {workouts.map(({ node }) => {
              const name = node.fields.slug.replace(/\//g, '')
              const resolutions = thumbnailResolutions[name]
              const numMentions = Array.isArray(node.frontmatter.mentions)
                ? node.frontmatter.mentions.length
                : 0
              return (
                <Grid key={name} xs={11} sm={6} md={4} lg={3} xl={2} item>
                  <SimpleCard
                    height={250}
                    gatsbyResolutions={resolutions}
                    caption={
                      <Link to={node.fields.slug}>{startCase(name)}</Link>
                    }
                    title={startCase(name)}
                    meta={
                      <div style={{ fontWeight: 500, position: 'relative' }}>
                        Mentioned{' '}
                        <span className={classes.mentionCount}>
                          {numMentions}
                        </span>{' '}
                        times
                        <Link to={node.fields.slug}>
                          <Button
                            classes={{ root: classes.goButton }}
                            size="small"
                            variant="raised"
                          >
                            Go
                          </Button>
                        </Link>
                      </div>
                    }
                  />
                </Grid>
              )
            })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
} //

WeightLossWorkoutsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
}

// prettier-ignore
// eslint-disable-next-line
export const WeightLossWorkoutsPageQuery = graphql`
  query WeightLossWorkoutsPageQuery {
    site {
      siteMetadata {
        siteUrl
        siteName
        siteDescription
      }
    }
    allMarkdownRemark(filter: { frontmatter: {pageType: {eq:"workout"}}}) {
      edges {
        node {
          timeToRead
          html
          fields {
            slug
          }
          frontmatter {
            title
            shortDescription
            tags
            mentions
          }
        }
      }
    }
    markdownRemark(frontmatter: { title: { eq: "Workouts" } } ) {
      html
    }
    allImageSharp(filter: { id: { regex: "/\/images\/workouts/" } }) {
      edges {
        node {
          resolutions(width: 500, traceSVG: { color: "#285978"}) {
            originalName
            ...GatsbyImageSharpResolutions_tracedSVG
          }
        }
      }
    }
  }
`

// prettier-ignore
export default compose(
  withStyles(styles),
)(WeightLossWorkoutsPage)



// WEBPACK FOOTER //
// ./src/pages/weight-loss-workouts.js